module.exports = __webpack_public_path__ + "static/media/skillsometer.d3826ad5.png";